angular.module('unergie.main')
.factory('JiraConstants', () => {
    const epics = {
        'SN2-822': 'Demande journée',
        'SN2-823': 'Demande express',
        'SN2-824': 'Standard hors délais',
        'SN2-934': 'Rappel finalisation commande',
        'SN2-1650': 'Annulation coupure/limitation/résiliation',
        'SN2-4581': 'Rétablissement KO',
        'SN2-4673': 'Rétablissement',
    }

    const sipperecFieldsJiraMapping = {
        key: 'key',
        created: 'created',
        type: 'issuetype',
        summary: 'summary',
        description: 'description',
        status: 'status',
        initiator: 'cf[10804]',
        id_prm: 'cf[10801]',
    }

    const priorityEnum = [{
        label: 'Normale',
        value: 'Normale',
    }, {
        label: 'Haute',
        value: 'Urgente',
    }]

    const typeEnum = [
        {
            label: 'Tâche',
            value: 'Task',
        }, {
            label: 'Bogue',
            value: 'Bug',
        },
    ]

    return {
        epics,
        priorityEnum,
        sipperecFieldsJiraMapping,
        typeEnum,
    }
})
